<template>
  <div class="Enrolment">
    <Header msg='我要报读' />

    <div class="Enrolment-personal">
      <!-- 报读类型 -->
      <div class="per-line">
        <div class=" flex flex-j-c-sb">
          <span>报读类型</span>
          <!-- <span class="text-yellow">{{titleType.enrolment_name||'暂无选择'}}</span> -->
          <div class="flex flex-j-c-e method-right" @click="showPopup('titleType')">
            <span class="text-yellow">{{titleType.enrolment_name||'暂无选择'}}</span>
            <img class="right-icon" src="@/assets/right-yellow.png">
          </div>
        </div>
      </div>
      <!-- 年级 -->
      <div class="per-line">
        <div class=" flex flex-j-c-sb">
          <span>年级</span>
          <!-- <span class="text-yellow">{{major.examination_year || '未选择相关专业'}}</span> -->
          <!-- <span class="text-yellow">2020</span> -->
          <span class="text-yellow">{{pageData.grade}}</span>
        </div>
      </div>
      <!-- 姓名 -->
      <div class="per-line">
        <div class="flex flex-j-c-sb flex-a-i-center">
          <span>姓名<i style="color:red">*</i></span>
          <input type="text" placeholder="请输入您的真实姓名" v-model.trim="uname" />
        </div>
      </div>
      <!-- 身份证 -->
      <div class="per-line">
        <div class="flex flex-j-c-sb flex-a-i-center">
          <span>身份证<i style="color:red">*</i></span>
          <input type="text" placeholder="请输入您的身份证号码" v-model.trim="uid" oninput="if(value.length > 18)value = value.slice(0, 18)" @blur.prevent="checkIdCard()" />
        </div>
      </div>
      <!-- 手机号码 -->
      <div class="per-line">
        <div class="flex flex-j-c-sb flex-a-i-center">
          <span>手机号码<i style="color:red">*</i></span>
          <input type="number" placeholder="请输入您的手机号码" v-model.trim="uphone" class="text-yellow" v-if="!pageData.mobile" oninput="if(value.length > 11)value = value.slice(0, 11)" @blur.prevent="checkPhoneNum()" />
          <span class="text-yellow" v-else>{{pageData.mobile}}</span>
        </div>
      </div>
      <!-- 验证码 -->
      <!-- <div class="per-line" v-if="!pageData.mobile">
        <div class="flex flex-j-c-sb flex-a-i-center">
          <input type="text" placeholder="请输入您的验证码" v-model.trim="ucheck" class="left" />
          <div class="btn-box"> -->
      <!-- <span class="check-btn">获取验证码</span> -->
      <!-- <span class="check-btn" v-if="seconds < 60" style="color:#FABF01">{{seconds}}S</span>
            <span class="check-btn" @click="getCode" v-else>获取验证码</span>
          </div>
        </div>
      </div> -->
      <!-- 单位名称 -->
      <div class="per-line">
        <div class="flex flex-j-c-sb flex-a-i-center">
          <span>工作单位<i style="color:red">*</i></span>
          <input type="text" placeholder="请输入单位名称" v-model.trim="dwname" />
        </div>
      </div>
      <!--测试城市-->

      <!-- <region-selects :town="true" @change="regionChange" /> -->
      <!-- 城市 -->
      <!-- <div class="per-line">
        <div class=" flex flex-j-c-sb">
          <span>现住址<i style="color:red">*</i></span>
          <div class="flex flex-j-c-e method-right">
            <span class="ellipsis">{{county||'请选择'}}</span>

          </div>
        </div>
      </div> -->
      <!-- 详细地址-->

      <div class="per-line">

        <div  class="flex flex-j-c-sb flex-a-i-center address1">
          <div style="text-align : left;width: 100px;">联系地址<i style="color:red">*</i></div>
          <div style="color: #FABF01;width: 78%; "><v-region-selects style="display: flex;" @change="regionChange" :town="true" /></div>
        </div>
      
      </div>
<div class="per-line">

       
        <div>
          <input style="width: 100%;height: 30px; text-align:left" type="text" placeholder="请输入详细地址" v-model="county" />
        </div>
      </div>
      <!-- 紧急联系人-->

      <div class="per-line">
        <div class="flex flex-j-c-sb flex-a-i-center">
          <span>紧急联系人<i style="color:red">*</i></span>
          <input type="text" placeholder="请输入紧急联系人姓名" v-model.trim="clman" />
        </div>
      </div>

      <!-- 紧急联系人电话号码-->
      <div class="per-line">
        <div class=" flex flex-j-c-sb">
          <span>电话号码<i style="color:red">*</i></span>
          <input type="text" placeholder="请输入紧急联系人手机号码" v-model.trim="cmobile" />
        </div>
      </div>

      <!-- 邀请人 -->
      <!-- <div class="per-line" v-if="showInviter">
        <div class=" flex flex-j-c-sb">
          <span>邀请人</span>
          <div class="flex flex-j-c-e method-right" @click="showPopup('inviter')">
            <span>{{inviter.true_name || inviter.nickname || '请选择'}}</span>
            <img class="right-icon" src="@/assets/right-yellow.png">
          </div>
        </div>
      </div> -->
    </div>
    <div class="enrolmentTips">志愿信息，可后续填写</div>
    <div class="Enrolment-choose">
      <!-- 层次 -->
      <div class="per-line">
        <div class=" flex flex-j-c-sb">
          <span>层次<i style="color:red">*</i></span>
          <div class="flex flex-j-c-e method-right" @click="showPopup('arrangement')">
            <span class="text-yellow">{{arrangement.name||'请选择'}}</span>
            <img class="right-icon" src="@/assets/right-yellow.png">
          </div>
        </div>
      </div>
      <!-- 院校 -->
      <div class="per-line">
        <div class=" flex flex-j-c-sb">
          <span>院校<i style="color:red">*</i></span>
          <div class="flex flex-j-c-e method-right" @click="showPopup('college')">
            <span class="text-yellow">{{college.name||'请选择'}}</span>
            <img class="right-icon" src="@/assets/right-yellow.png">
          </div>
        </div>
      </div>

      <!-- 专业 -->
      <div class="per-line">
        <div class=" flex flex-j-c-sb">
          <span>专业<i style="color:red">*</i></span>
          <div class="flex flex-j-c-e method-right text-yellow" @click="showPopup('major')">
            <span class="text-yellow">{{major.name||'请选择'}}</span>
            <img class="right-icon" src="@/assets/right-yellow.png">
          </div>
        </div>
      </div>
      <!-- 服务校区 -->
      <div class="per-line">
        <div class=" flex flex-j-c-sb">
          <span>上课校区<i style="color:red">*</i></span>
          <div class="flex flex-j-c-e method-right" @click="showPopup('servicCampus')">
            <span class="text-yellow">{{servicCampus.name||'请选择'}}</span>
            <img class="right-icon" src="@/assets/right-yellow.png">
          </div>
        </div>
      </div>

    </div>

    <mt-button @click.native="toConfirmation" size="large">下一步</mt-button>

    <!-- 优惠券弹窗 -->
    <div class="mask" @touchmove.prevent :class="!showMask ? 'Enrolment-Hide':'Enrolment-Show'">
      <div class="showMask">
        <h3>领取优惠券</h3>
        <div>
          <mt-field placeholder="请输入手机号码" type="tel" v-model="uphone"></mt-field>
        </div>

        <div class="flex flex-j-c-sb">
          <mt-field placeholder="请输入验证码" type="text" v-model="ucheck" style="width:50%;"></mt-field>
          <div class="btn-box">
            <span class="check-btn" v-if="seconds < 60" style="color:#FABF01">{{seconds}}S</span>
            <span class="check-btn" @click="getCode" v-else>获取验证码</span>
          </div>
        </div>
        <div class="mask-tips">
          <p class="text-yellow">领取优惠券前需进行身份验证，才可正常使用哦~</p>
        </div>

        <div class="mask-btn flex flex-j-c-center">
          <p class="text-yellow" @click="closeMask">暂时放弃</p>
          <p class="btn-right">确认领取</p>
        </div>
      </div>
    </div>

    <mt-popup v-model="popupVisible" popup-transition="popup-fade" position="bottom" class="mint-popup">
      <mt-picker :slots="slots" :valueKey="Indexes" @change="onValuesChange" :itemHeight="50" showToolbar ref="picker">
        <mt-header :title.sync="popupName">
          <mt-button slot="left" @click="popupVisible = false">取消</mt-button>
          <mt-button slot="right" @click="handleConfirm">确定</mt-button>
        </mt-header>
      </mt-picker>
    </mt-popup>
  </div>
</template>

<script>
import Header from '@/components/Header.vue'
import {
  previewSubmit,
  modityLink,
  cityLink,
  campusLink,
  forderSubmit,
  REQUEST_BASE,
  getMessage,
  FuserMsg,
} from '@/api'
import { Toast, MessageBox } from 'mint-ui'

export default {
  name: 'Enrolment',
  components: {
    Header,
  },
  data() {
    return {
      region: {
        province: '350000',
        city: '350100',
        area: '350104',
        town: '350104008',
      },
      showMask: false, // 选择优惠券弹窗（弃用）
      uname: '', // 姓名
      uid: '', // 身份证号码
      uphone: '', // 手机
      cmobile: '',
      // detailed_address: '',
      county: '',
      ucheck: '', // 验证码
      seconds: 60, // 验证码倒计时
      t: '', // timer 短信
      popupVisible: false, // picker 显示/隐藏
      popupType: '', // 联动类型
      popupName: '', // 联动名称
      Indexes: 'name', // 联动索引

      titleType: {}, // 报读类型
      college: {}, // 校区
      dwname: '', // 单位名称
      clman: '', //紧急联系人姓名
      arrangement: {}, // 层次
      major: {}, // 专业
      city: [{ id: 1941 }, { id: 1942 }], // 城市
      cityShow: '', // 城市展示数据
      servicCampus: {}, // 服务校区
      inviter: {}, // 邀请人

      slots: [{ flex: 1, values: [], className: 'slot1', textAlign: 'center' }], // 联动弹窗数据
      pageData: { list: [], fans: [], enroll: [] }, // 获取预报名数据
      cityData: '', // 获取的城市数据
      changeCityIndex: [0, 0, 0], // 城市更改id
      cindex: 0, // 城市联动默认下标
      servicCampusArr: [], // 校区联动数据
      showInviter: true, // 控制是否可显示邀请人选项
      inviterIndex: 0, // 邀请人联动默认下标
      parentId: 0, // 邀请人id
    }
  },
  created() {
    this.getPreView()
    this.getCity()
    this.getCampus(0)
    /** ------------------------------------自动填充相关--------------------------------------------- */
    this.uname = localStorage.getItem('cww_FillInData')
      ? JSON.parse(localStorage.getItem('cww_FillInData')).pdName
      : ''
    /** ------------------------------------自动填充相关--------------------------------------------- */
  },
  methods: {
    regionChange(data) {
     // console.log(data)

      // console.log(
      //   data.province.value + '-' + data.city.value + '-' + data.area.value + '-' + data.town.value
      // )
      if (data.province != null) {
        this.county = data.province.value
      }
      console.log(this.county)
      if (data.city != null) {
        this.county = this.county + '-' + data.city.value
      }
      console.log(this.county)
      if (data.area != null) {
        this.county = this.county + '-' + data.area.value
      }
      console.log(this.county)
      if (data.town != null) {
        this.county = this.county + '-' + data.town.value
      }
      console.log(this.county)
    },
    // 预报名数据获取接口
    getPreView() {
      previewSubmit().then((res) => {
        console.log(res)
        if (res.code === 102) {
          Toast({ message: '已存在报名记录', className: 'iconfont icon-close', duration: 1500 })
          setTimeout(() => {
            this.$router.push({ name: 'Order' })
          }, 1500)
        } else {
          this.pageData = res.data

          if (this.pageData.fans.length === 0) {
            // 暂无邀请人
            this.inviter = { id: -1, nickname: '暂无' }
          } else {
            // 存在邀请人
            this.pageData.fans.map((item, index) => {
              if (item.true_name) {
                item.nickname = item.true_name
              }
            }) // 展示邀请人真实姓名
            if (localStorage.getItem('_lastshareid')) {
              // 检测最后邀请用户的邀请人id
              this.pageData.fans.map((item, index) => {
                if (item.inviter_id == localStorage.getItem('_lastshareid')) {
                  this.inviter = item
                  this.inviterIndex = index
                }
              })
            } else {
              this.inviter = this.pageData.fans[this.pageData.fans.length - 1]
            }
          }
          // 报读类型
          if (this.pageData.enroll.length !== 0) {
            this.titleType = this.pageData.enroll[this.pageData.enroll.length - 1]
            // this.titleType = 1
          }
          // 院校
          if (this.pageData.list.length !== 0) {
            let colObj = {}
            this.pageData.list.map((item, index) => {
              if (item.id == 68) {
                this.college = item
                console.log(this.college)
                // this.arrangement = item.son[0];
                // this.getModity(1)
                colObj.item = item
                colObj.index = index
              }
            })
            this.pageData.list.splice(colObj.index, 1)
            this.pageData.list.push(colObj.item)
          }
        }
        let paramsData = JSON.parse(sessionStorage.getItem('_previewData'))

        if (paramsData) {
          this.uname = paramsData.params.true_name
          this.clman = paramsData.params.crash_linkman
          this.uphone = paramsData.params.mobile
          this.cmobile = paramsData.params.cmobile
          // this.detailed_address = paramsData.params.detailed_address
          this.county = paramsData.params.county
          this.dwname = paramsData.params.dwname
          this.ucheck = paramsData.params.mobile_code
          this.uid = paramsData.params.idcard
          this.titleType = paramsData.paramsShow.enrolment
          this.college = paramsData.paramsShow.first_cat
          this.city == [{ id: 1941 }, { id: 1942 }], // 城市
            // this.dwname = paramsData.paramsShow.dwname_cat //添加

            (this.arrangement = paramsData.paramsShow.second_cat)
          this.major = paramsData.paramsShow.goods
          this.servicCampus = paramsData.paramsShow.campus
          this.inviter = paramsData.paramsShow.inviter
        }
        window.scrollTo(0, 0)
        this.getUserMsg()
      })
    },
    // 用户信息获取(非学员用户不可选择邀请人，默认选择上一级)
    getUserMsg() {
      FuserMsg().then((res) => {
        this.parentId = res.data.parent_id || 0

        // ------------------
        // res.data.exist_invite = 1
        // res.data.fans_amount = 100
        // ------------------
        // 非学员时 邀请人判断
        if (res.data.level >= 2) {
          if (
            localStorage.getItem('_lastshareid') &&
            (res.data.exist_invite == 0 || Number(res.data.fans_amount) < 100)
          ) {
            let inviMsg = JSON.parse(localStorage.getItem('_lastshareUser')) || '{}'
            if (localStorage.getItem('_lastshareid') != res.data.parent_id && inviMsg.level > 2) {
              MessageBox(
                '提示',
                `${res.data.true_name || res.data.nickname}，您好！您的合伙人推荐是：${
                  res.data.tParent || res.data.parent
                }，现扫码推荐人是：${
                  inviMsg.true_name || inviMsg.nickname
                }，请在推荐人列表选择报名推荐人！`
              )
              this.inviter = {}
              // 如果不是该用户的推荐人，则加到推荐人列表
              if (this.pageData.fans.filter(this.checkAdult).length == 0) {
                this.pageData.fans.unshift({
                  inviter_id: res.data.parent_id,
                  nickname: res.data.tParent || res.data.parent,
                })
              }
              this.parentId = inviMsg.id || 0
              if (this.pageData.fans.filter(this.checkAdult).length == 0) {
                this.pageData.fans.unshift({
                  inviter_id: inviMsg.id,
                  nickname: inviMsg.true_name || inviMsg.nickname,
                })
              }
            } else {
              this.inviter = {
                inviter_id: res.data.parent_id,
                nickname: res.data.tParent || res.data.parent,
              }
              this.pageData.fans = []
              this.showInviter = false
            }
          } else {
            this.inviter = {
              inviter_id: res.data.parent_id,
              nickname: res.data.tParent || res.data.parent,
            }
            this.pageData.fans = []
            this.showInviter = false
          }
        }
      })
    },
    // 筛选邀请人（判断是否存在当前邀请人）
    checkAdult(item) {
      return item.inviter_id == this.parentId
    },
    // 专业联动数据接口
    getModity(e) {
      let params = {
        first_cat_id: this.college.id,

        // first_cat_id: 1, // 院校id
        second_cat_id: this.arrangement.id, // 层次id
        // second_cat_id: 1,
      }
      modityLink(params).then((res) => {
        if (res.code === 0) {
          if (e === 1) {
            this.major = res.data[0]
          } else {
            if (this.slots[0].values !== res.data) {
              this.slots = [{ flex: 1, values: res.data, className: 'slot1', textAlign: 'center' }]
              this.popupType = 'major'
              this.popupName = '选择专业'
              this.Indexes = 'name'
            }
            this.popupVisible = true
          }
        } else {
          Toast({ message: res.msg, className: 'iconfont icon-close' })
        }
      })
    },
    // 城市联动接口
    getCity() {
      cityLink().then((res) => {
        this.cityData = res.data

        let defaultCity = [{}, {}],
          cindex = 0
        if (res.data.length !== 0) {
          res.data.map((item, index) => {
            if (item.id === 19411) {
              this.cityData = [item]
              defaultCity[0] = item
              defaultCity[1] = item.list[0]
              console.log(item.list[0])
              cindex = index
            }
          })
          this.city = defaultCity
          this.cindex = cindex
          this.cityShow = localStorage.getItem('cityShow')
          // this.cityShow = `${this.city[0].name}-${this.city[1].name}`
        }
      })
    },
    // 校区联动接口
    getCampus(e = this.city[1].id) {
      console.log((e = this.city[1].id))
      campusLink({ city_id: e }).then((res) => {
        if (res.code === 0) {
          // if(this.slots[0].values !== res.data) {
          //   this.slots = [{flex: 1, values: res.data, className: 'slot1', textAlign: 'center'}];
          //   this.Indexes = 'name';
          //   this.popupType = 'servicCampus';
          //   this.popupName = '选择校区';
          // }
          // this.popupVisible = true;
          this.servicCampusArr = res.data
          // this.servicCampus = res.data[0];
        } else {
          this.servicCampus = { name: '暂无' }
        }
      })
    },
    // 选择选项
    showPopup(str) {
      let judge = true
      switch (str) {
        case 'titleType': // 报读类型
          if (this.pageData.enroll.length === 0) {
            Toast({ message: '暂无数据', className: 'iconfont icon-close' })
            judge = false
          }
          if (this.pageData.enroll !== this.slots[0].values) {
            this.slots = [
              { flex: 1, values: this.pageData.enroll, className: 'slot1', textAlign: 'center' },
            ]
            this.Indexes = 'enrolment_name'
            this.popupName = '选择报读类型'
          }
          break
        case 'college': // 院校
          if (this.pageData.list.length === 0) {
            Toast({ message: '暂无数据', className: 'iconfont icon-close' })
            judge = false
          }
          if (this.pageData.list !== this.slots[0].values) {
            this.slots = [
              { flex: 1, values: this.pageData.list, className: 'slot1', textAlign: 'center' },
            ]
            this.Indexes = 'name'
            this.popupName = '选择院校'
          }
          break
        case 'arrangement': // 层次
          if (!this.college.id) {
            Toast({ message: '请选择院校', className: 'iconfont icon-close' })
            judge = false
          } else if (this.college.son.length === 0) {
            Toast({ message: '暂无层次信息', className: 'iconfont icon-close' })
            judge = false
          }
          if (this.college.son !== this.slots[0].values) {
            this.slots = [
              { flex: 1, values: this.college.son, className: 'slot1', textAlign: 'center' },
            ]
            this.Indexes = 'name'
            this.popupName = '选择层次'
          }
          break
        case 'major': // 专业
          if (!this.arrangement.id) {
            Toast({ message: '请选择层次', className: 'iconfont icon-close' })
            judge = false
          } else {
            this.getModity(0)
            judge = false
          }
          break
        case 'city': // 城市
          let province = this.cityData
          let city = this.cityData[0].list
          let district = this.cityData[0].list[0].list
          console.log(province)
          console.log(city)
          console.log(district)
          // let district = this.cityData[0].list[0].list;
          this.slots = [
            {
              flex: 1,
              values: province,
              className: 'slot1',
              textAlign: 'center',
              defaultIndex: this.cindex,
            },
            {
              divider: true,
              content: '-',
              className: 'slot2',
            },
            {
              flex: 1,
              values: city,
              className: 'slot3',
              textAlign: 'center',
            },

            {
              divider: true,
              content: '-',
              className: 'slot2',
            },
            {
              flex: 1,
              values: district,
              className: 'slot4',
              textAlign: 'center',
            },
          ]
          // this.servicCampus = {}
          this.popupName = '城市'
          break
        case 'servicCampus': // 服务校区
          if (this.county == '') {
            Toast({ message: '请选择城市', className: 'iconfont icon-close' })
            judge = false
          } else {
            // this.getCampus();
            if (this.slots[0].values !== this.servicCampusArr) {
              this.slots = [
                { flex: 1, values: this.servicCampusArr, className: 'slot1', textAlign: 'center' },
              ]
              this.Indexes = 'name'
              this.popupName = '选择校区'
            }
            // judge = false
          }
          if (this.servicCampusArr.length === 0) {
            Toast({ message: '暂无可选择校区', className: 'iconfont icon-close' })
            judge = false
          }
          break
        case 'inviter': // 邀请人
          if (this.pageData.fans.length === 0) {
            Toast({ message: '暂无邀请人', className: 'iconfont icon-close' })
            this.inviter = { nickname: '暂无' }
            judge = false
          }
          if (this.pageData.fans !== this.slots[0].values) {
            this.slots = [
              {
                flex: 1,
                values: this.pageData.fans,
                className: 'slot1',
                textAlign: 'center',
                defaultIndex: this.inviterIndex,
              },
            ]
            this.Indexes = 'nickname'
            this.popupName = '选择邀请人'
          }
          break
        default:
          Toast({ message: '请稍后重试', className: 'iconfont icon-close' })
          judge = false
          break
      }
      if (judge) {
        this.popupVisible = true
        this.popupType = str
      }
    },
    // 变更选项
    onValuesChange(picker, values) {
      console.log(values)
      if (!this.popupType) return false
      if (this.popupType === 'city') {
        let province = values[0]
        console.log(province)
        let city = values[1]
        console.log(city)
        let district = values[2]
        console.log(district)
        if (province.id !== this.changeCityIndex[0].id) {
          this.changeCityIndex[0] = province.id
          picker.setSlotValues(1, province.list)
          // picker.setSlotValues(2, province.list[0].list)
        }
        if (city.id !== this.changeCityIndex[1].id) {
          this.changeCityIndex[1] = city.id
          picker.setSlotValues(2, city.list)
        }
        if (district.id !== this.changeCityIndex[2].id) {
          this.changeCityIndex[2] = district.id
          picker.setSlotValues(2, province.list[0].list)
          picker.setSlotValues(2, city.list)
          console.log(province.list[0].list)
        }
      }
    },
    // 确定选项
    handleConfirm() {
      switch (this.popupType) {
        case 'titleType':
          this.titleType = this.$refs.picker.getValues()[0]
          break
        case 'college':
          this.college = this.$refs.picker.getValues()[0]
          // this.arrangement = {} // 层次清空
          // this.major = {} // 专业清空
          break
        case 'arrangement':
          this.arrangement = this.$refs.picker.getValues()[0]
          if (this.college.id == 68) {
            this.getModity(1)
          } else {
            this.major = {}
          }
          break
        case 'major':
          this.major = this.$refs.picker.getValues()[0]
          break
        case 'city':
          console.log(this.$refs.picker.getValues())
          this.city = [
            this.$refs.picker.getValues()[0],
            this.$refs.picker.getValues()[1],
            this.$refs.picker.getValues()[2],
          ]
          this.county = `${this.city[0].name}-${this.city[1].name}-${this.city[2].name}`
          console.log(this.county)
          // localStorage.setItem('cityShow', this.cityShow)

          break
        case 'servicCampus':
          this.servicCampus = this.$refs.picker.getValues()[0]
          break
        case 'inviter':
          this.inviter = this.$refs.picker.getValues()[0]
          break
        default:
          Toast({ message: '请稍后重试', className: 'iconfont icon-close' })
          break
      }
      this.popupVisible = false
    },
    // 提交订单
    toConfirmation() {
      let judge = true
      let params = {}
      let paramsShow = {}
      if (!this.uname) {
        Toast({ message: '请输入姓名', className: 'iconfont icon-close' })
        judge = false
        return false
      } else {
        params.true_name = this.uname
      }
      if (!this.clman) {
        Toast({ message: '请输入紧急联系人姓名', className: 'iconfont icon-close' })
        judge = false
        return false
      } else {
        params.crash_linkman = this.clman
      }
      if (!this.uid || !this._tools.checkIdentityLegal(this.uid)) {
        Toast({ message: '请输入正确的身份证号码', className: 'iconfont icon-close' })
        judge = false
        return false
      } else {
        params.idcard = this.uid
      }
      if (!this.pageData.mobile && (!this.uphone || !this._tools.checkPhone(this.uphone))) {
        Toast({ message: '请输入正确的手机号码', className: 'iconfont icon-close' })
        judge = false
        return false
      } else {
        params.mobile = this.pageData.mobile || this.uphone
      }
      if (!this.pageData.cmobile && (!this.cmobile || !this._tools.checkPhone(this.cmobile))) {
        Toast({ message: '请输入正确的紧急联系人手机号码', className: 'iconfont icon-close' })
        judge = false
        return false
      } else {
        params.cmobile = this.pageData.cmobile || this.cmobile
      }
      // if (!this.pageData.mobile && this.uphone && !this.ucheck) {
      //   Toast({ message: '请输入验证码', className: 'iconfont icon-close' })
      //   judge = false
      //   return false
      // } else {
      //   params.mobile_code = this.ucheck
      // }

      // ---------------
      if (!this.dwname) {
        Toast({ message: '请输入单位名称', className: 'iconfont icon-close' })
        judge = false
        return false
      } else {
        params.dwname = this.dwname
      }
      // ---------------

      // // if (!this.titleType.id) {
      // //   Toast({ message: '请选择报读类型', className: 'iconfont icon-close' })
      // //   judge = false
      // //   return false
      // // } else {
      // params.enrolment_id = 1
      // paramsShow.enrolment = 1
      // // }
      // // if (!this.major.id) {
      // //   Toast({ message: '请选择专业', className: 'iconfont icon-close' })
      // //   judge = false
      // //   return false
      // // } else {
      // params.goods_id = 2
      // paramsShow.goods = 2022
      // // }
      if (!this.titleType.id) {
        Toast({ message: '请选择报读类型', className: 'iconfont icon-close' })
        judge = false
        return false
      } else {
        params.enrolment_id = this.titleType.id
        paramsShow.enrolment = this.titleType
      }
      if (!this.major.id) {
        Toast({ message: '请选择专业', className: 'iconfont icon-close' })
        judge = false
        return false
      } else {
        params.goods_id = this.major.id
        paramsShow.goods = this.major
      }
      if (!this.servicCampus.id) {
        Toast({ message: '请选择服务校区', className: 'iconfont icon-close' })
        judge = false
        return false
      } else {
        params.campus_id = this.servicCampus.id
        paramsShow.campus = this.servicCampus
      }
      if (judge) {
        // params.first_cat_id = this.college.id
        // ;(params.user_id = 36831), (params.first_cat_id = this.college.id)
        // paramsShow.first_cat = this.college

        // params.second_cat_id = this.arrangement.id
        // params.second_cat_id = 1
        // paramsShow.second_cat = this.arrangement
        params.first_cat_id = this.college.id
        paramsShow.first_cat = this.college

        params.second_cat_id = this.arrangement.id
        paramsShow.second_cat = this.arrangement

        // params.enrolment_year = this.major.examination_year
        params.enrolment_year = this.pageData.grade

        params.inviter_id = this.inviter.inviter_id || 0
        paramsShow.inviter = this.inviter

        params.province_id = 1
        params.city_id = 1
        paramsShow.city = this.city

        params.url = `${REQUEST_BASE()}/Order`

        params.crash_linkman = this.clman
        // params.detailed_address = this.detailed_address
        params.crash_mobile = this.cmobile
        params.county = this.county
        params.unit = this.dwname
        paramsShow.enrolment_name = this.titleType.enrolment_name
        paramsShow.college_name = this.college.name

        paramsShow.arrangement_name = this.arrangement.name
        paramsShow.major_name = this.major.name

        paramsShow.city_name = this.city[1]
        paramsShow.servicCampus_name = this.servicCampus.name

        let previewData = { params: params, paramsShow: paramsShow }
        sessionStorage.setItem('_previewData', JSON.stringify(previewData))
        /** ------------------------------------自动填充相关--------------------------------------------- */
        if (localStorage.getItem('cww_FillInData')) {
          let PT = JSON.parse(localStorage.getItem('cww_FillInData'))
          PT.pdName = this.uname
          PT.pdPhone = this.uphone
          localStorage.setItem('cww_FillInData', JSON.stringify(PT))
        } else {
          localStorage.setItem(
            'cww_FillInData',
            JSON.stringify({ pdName: this.uname, pdPhone: this.uphone })
          )
        }
        /** ------------------------------------自动填充相关--------------------------------------------- */
        this.$router.push({ name: 'Confirmation' })
      }
    },
    // 短信
    getCode() {
      if (this.seconds < 60) return
      if (true) {
        console.log('验证码已发送')
        this.requestCode()
      } else {
        console.log('error')
      }
    },
    // 获取短信验证码
    requestCode() {
      getMessage({ content: this.uphone }).then((res) => {
        if (res.code === 0) {
          MessageBox('提示', '验证码发送，请注意查收！')
          this.t = setInterval(() => {
            this.seconds--
            if (this.seconds === 0) {
              clearInterval(this.t)
              this.seconds = 60
            }
          }, 1000)
        } else {
          Toast({ message: res.msg, className: 'iconfont icon-close' })
        }
      })
    },
    // 优惠券弹窗（弃用）
    closeMask() {
      this.showMask = false
    },
    // 检测身份证
    checkIdCard() {
      if (!this.uid) return false
      if (!this._tools.checkIdentityLegal(this.uid)) {
        Toast({ message: '请输入正确的身份证号码', className: 'iconfont icon-close' })
      }
    },
    // 检测手机号
    checkPhoneNum() {
      if (!this.pageData.mobile && (!this.uphone || !this._tools.checkPhone(this.uphone))) {
        Toast({ message: '请输入正确的手机号码', className: 'iconfont icon-close' })
      }
    },
  },
}
</script>

<style  lang="less" scoped>
.Enrolment {
  min-height: 100%;
  padding: 0.54rem 0 0.5rem;
  font-size: 0.16rem;
  .Enrolment-personal,
  .Enrolment-choose {
    padding: 0.12rem 0.16rem 0;
    background-color: white;
    & > :last-child {
      border: none;
    }
  }
  // .Enrolment-choose{
  //     margin-top: 0.1rem;
  // }

  .mint-popup /deep/ .picker {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    background: white;
    border-radius: 8px 8px 0 0;
    .mint-header {
      background: white;
      height: 0.5rem;
      padding: 0 0.16rem;
      font-size: 0.15rem;
      .is-left {
        color: #999999;
      }
      .is-right {
        color: #fabf01;
      }
    }
    .mint-header-title {
      font-size: 0.17rem;
      color: black;
    }
  }
  .mint-popup {
    width: 100%;
    border-radius: 8px 8px 0 0;
  }
  .btn-box {
    position: relative;
    height: 0.5rem;
    width: 0.8rem;
    .check-btn {
      position: absolute;
      display: block;
      width: 0.8rem;
      height: 0.24rem;
      line-height: 0.24rem;
      background: #f6f6fa;
      color: #333333;
      font-size: 0.14rem;
      top: 50%;
      transform: translateY(-50%);
      border-radius: 0.12rem;
    }
  }
  .showMask {
    background: white;
    border-radius: 6px;
    width: 80%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    padding: 0 0.16rem;
    h3 {
      line-height: 0.6rem;
    }
    .mask-btn {
      border-top: 1px solid #eeeeee;
      margin: 0 -0.16rem;
      p {
        width: 50%;
        height: 0.44rem;
        line-height: 0.44rem;
        font-size: 0.14rem;
        border-radius: 0 0 0 6px;
      }
      .btn-right {
        background: #fabf01;
        color: white;
        border-radius: 0 0 6px 0;
      }
    }
    .mask-tips {
      height: 0.5rem;
      padding: 0.16rem 0;
      border-top: 1px solid #eeeeee;
      p {
        background: rgba(255, 221, 113, 0.2);
        border-radius: 3px;
        font-size: 0.12rem;
      }
    }
  }
}
.Enrolment /deep/ .picker-selected {
  color: #fabf01;
}

.Enrolment-Show {
  display: block;
  -webkit-animation: navShow 0.3s;
  animation: navShow 0.3s;
}
.Enrolment-Hide {
  display: none;
  -webkit-animation: navHide 0.3s;
  animation: navHide 0.3s;
}
input {
  height: 0.48rem;
}
.enrolmentTips {
  line-height: 0.37rem;
  text-align: left;
  margin-left: 0.16rem;
  color: #666666;
  font-size: 0.14rem;
}
/deep/ div.rg-select div.rg-select__el div.rg-select__content {
  padding: 0;
  color:#FABF01;
  min-width: 70px;
  height: 90%;
}
/deep/ div.rg-select  {
  padding:1px;
  margin-right: 2px;
}
/deep/ div.rg-select__el  {
  border: 1px solid #fabf01;
  border-radius: 10px;
}
</style>
